export default __webpack_public_path__ + "static/treatmentareas_bikinibefore-9aff6d3aa9da6b00818430f2ba93dbfd.webp";